import React, { memo } from 'react';
import { IStyle } from 'Styles';

const NoDataFound = () => <div id="generic-nodatafound" style={styles.root}>No Data Found...</div>;

const styles: IStyle = {
  root: {
    fontWeight: 600,
    color: '#f86e02',
    fontSize: '2vh',
  },
};

export default memo(NoDataFound);
